export default __webpack_public_path__ + "static/makecode_16x-8401286e00b700c33f69c95494cf1598.svg";